import { Injectable } from "@angular/core";
import {
    DepartmentClient
} from "../WebApiClient";


@Injectable({
    providedIn: "root"
})
export class DepartmentService {
    public constructor (private readonly client: DepartmentClient) {
    }

    public getAllDepartments() {
        return this.client.getAllDepartments();
    }

    public getUserDepartments(userId: string) {
        return this.client.getDepartmentsForUser(userId);
    }
}
